 <template>
  <!--   Loading   -->
  <div class="loading" v-show="visible">
    <div class="loading-bg">
      <div class="close" @click="$emit('update:visible', false)">×</div>
      <i class="el-icon-loading"></i>
      <div class="loading-text">{{LoadingText || "正在处理，请稍候"}}</div>
      <!-- <div class="loading-btn" @click="$emit('update:visible', false)">关闭</div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "loading",
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    LoadingText: {
      type: String,
      default: "正在处理，请稍候",
    },
  },
};
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  z-index: 30000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .loading-bg {
    height: 250px;
    min-width: 250px;
    background: #080808;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .close {
      font-size: 20px;
      font-weight: 400;
      color: #fff;
      border: #fff solid 1px;
      width: 20px;
      text-align: center;
      height: 20px;
      line-height: 20px;
      border-radius: 20px;
      float: right;
      margin: -30px -190px 0 0;
    }
  .el-icon-loading {
    color: #ffffff;
    font-size: 55px;
    margin-top: 40px;
  }

  .loading-text {
    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    line-height: 46px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    padding: 0 20px;
    margin: 20px 0 0 0;
  }

  .loading-btn {
    width: 150px;
    height: 40px;
    background-color: #4438d4;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid #695cff;

    font-weight: normal;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    margin: 10px 0 0 0;

    cursor: pointer;
  }

  .loading-btn:hover {
    border: 1px solid #aba4ff;
  }
}
</style>
